import { deflate, inflate } from 'pako';

export const compressString = (uncompressedData: string) =>
    btoa(
        Array.from(
            deflate(uncompressedData, {
                level: 9,
            }),
        )
            .map((n) => String.fromCharCode(n))
            .join(''),
    );

export const decompressString = (compressedData: string) => {
    return new TextDecoder().decode(
        inflate(
            new Uint8Array(
                atob(compressedData)
                    .split('')
                    .map((char) => char.charCodeAt(0)),
            ),
        ),
    );
};
